import { fromJS, List } from 'immutable';
import _ from 'lodash';
import { handleActions } from 'redux-actions';
import { SET_TABLES_DATA } from '../socket/constants';
import { SET_TABLES } from './constants';

const initialState = fromJS({
	tables: [],
});

const parseData = (d: any) => {
	if (parseInt(d.stmomo, 10) === 100) {
		d.tftf_90th = d.tftf;
		d.tftf_10th = d.tftf_tid;
		d.signal90_value = d.tftf_indicator;
		d.signal10_value = d.tftf_tid_indicator;
	} else if (parseInt(d.stmomo, 10) === -100) {
		d.tftf_90th = d.tftf_tid;
		d.tftf_10th = d.tftf;
		d.signal90_value = d.tftf_tid_indicator;
		d.signal10_value = d.tftf_indicator;
	}
	return d;
};

export default handleActions({
	[SET_TABLES]: (state: any, { payload }: any) =>
		state.update('tables', () => List(payload.tables.map((item: any) => item))),
	[SET_TABLES_DATA]: (state: any, { payload }: any) => {
		const tables = _.map(_.values(payload.data),
			data => {
				if (data.model !== undefined) { data.model = data.model.replace('1440min', 'Daily') }
				data = parseData(data);
				return data;
			},
		);
		return state.update('tables', () => List(_.differenceBy(state.toJS().tables, tables, 'model').concat(tables).map(item => item)));
	},
}, initialState);
